import { PopoverListItem, PopoverListItemIcon, PopoverListItemText } from 'isolated-design-library'

import { DownloadIcon, TrashIcon, useSnackbar } from '@forgeglobal/design-framework'
import { FileFragment, GetDocumentsByAccountDocument, useDeleteFileMutation } from 'graphql/bindings/AdminBindings'
import { download } from 'util/DocumentUtils'
import React, { Fragment } from 'react'

interface DocumentActionsProps {
  file: FileFragment
  accountId: string
  type: 'primary' | 'related'
}

const DocumentActions: React.FC<DocumentActionsProps> = ({ file, accountId, type }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [mutate] = useDeleteFileMutation()

  const removeDocument = () => {
    mutate({
      variables: {
        fileId: file.id,
      },
      refetchQueries: [{ query: GetDocumentsByAccountDocument, variables: { accountId } }],
    }).then(() => {
      enqueueSnackbar(`Document ${file.filename} removed`)
    })
  }

  const handleDownload = () => {
    enqueueSnackbar(`Downloading document ${file.filename} ...`)
    download(file)
  }

  return (
    <Fragment>
      <PopoverListItem button onClick={handleDownload}>
        <PopoverListItemIcon>
          <DownloadIcon />
        </PopoverListItemIcon>
        <PopoverListItemText>Download</PopoverListItemText>
      </PopoverListItem>
      {type === 'primary' && (
        <PopoverListItem button onClick={removeDocument}>
          <PopoverListItemIcon>
            <TrashIcon />
          </PopoverListItemIcon>
          <PopoverListItemText>Remove</PopoverListItemText>
        </PopoverListItem>
      )}
    </Fragment>
  )
}

export default DocumentActions
